export const BASE_URL = "";
export const CAPTCHA_URL = "/epms/api/v1/admin/otps";